import { render, staticRenderFns } from "./ScrollingCardsView.vue?vue&type=template&id=f6896b6a&scoped=true&"
import script from "./ScrollingCardsView.vue?vue&type=script&lang=js&"
export * from "./ScrollingCardsView.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingCardsView.vue?vue&type=style&index=0&id=f6896b6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6896b6a",
  null
  
)

export default component.exports